// Applies an associate's white-label colours/logo to the app shell; nothing set → Kinntegra defaults from index.css.
import { useSyncExternalStore } from "react";

let logo = null;
const subs = new Set();
export const setBrandLogo = (url) => { if (logo && logo !== url) URL.revokeObjectURL(logo); logo = url; subs.forEach((f) => f()); };
export const useBrandLogo = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => logo);
const VARS = ["--brand-1", "--brand-1m", "--brand-1b", "--brand-2", "--primary", "--ring"];

const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
const shade = ([r, g, b], f) => [r, g, b].map((c) => Math.round(c * f)).join(" ");
const hsl = ([r, g, b]) => {
  const [R, G, B] = [r / 255, g / 255, b / 255];
  const mx = Math.max(R, G, B), mn = Math.min(R, G, B), l = (mx + mn) / 2, d = mx - mn;
  if (!d) return `0 0% ${Math.round(l * 100)}%`;
  const s = d / (1 - Math.abs(2 * l - 1));
  const h = mx === R ? ((G - B) / d) % 6 : mx === G ? (B - R) / d + 2 : (R - G) / d + 4;
  return `${Math.round((h * 60 + 360) % 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

export function applyBranding({ primary_color: p, secondary_color: s } = {}) {
  const st = document.documentElement.style;
  VARS.forEach((v) => st.removeProperty(v));
  if (p) {
    const c = rgb(p);
    st.setProperty("--brand-1b", shade(c, 1));
    st.setProperty("--brand-1m", shade(c, 0.65));
    st.setProperty("--brand-1", shade(c, 0.4));
    st.setProperty("--primary", hsl(c));
    st.setProperty("--ring", hsl(c));
  }
  if (s) st.setProperty("--brand-2", rgb(s).join(" "));
}
